/**
 * Enum representing the supported control types for model values and UI elements.
 */
export enum EnumControlTypes {

  /**
   * Grid for users to add blended rates.
   */
  GridBlr = 'grid-blr',


  /**
   * Checkbox control type.
   */
  Checkbox = 'chk',

  /**
   * Default chart supporting config
   */
  ChartDef = 'chart-def',

  /**
   * Country selector control type.
   */
  Country = 'ctry',

  /**
   * Date picker control type.
   */
  Date = 'dt',

  /**
   * Default title control type.
   */
  DefaultTitle = 'ttld',

  /**
   * Description text control type.
   */
  DescriptionText = 'desc',

  /**
   * Double (floating-point number) input control type.
   */
  Double = 'dbl',

  /**
   * Grid for user input, data collected by column
   */
  GridInputByColumn = 'grid-i-col',

  /**
   * Grid for user input, data collected by row
   */
  GridInputByRow = 'grid-i-row',

  /**
   * Grid with no user input, supports configurable data bound data within rows that are dynamically defined by deal duration.
   */
  GridOutput = 'grid-o',

  /**
 * To be relegated, Grid with no user input, supports configurable data bound data within rows.
 */
  GridWithRows = 'grid_with_rows',

  /**
   * Grid header control type.
   */
  GridHeader = 'grid_hdr',

  /**
   * Grid header with merged cells control type.
   */
  GridHeaderMerge = 'grid_hdr_merge',

  /**
   * Dynamic grid heaaders for time inputs, columns defined by deal duration
   */
  GridHeaderTime = 'grid_hdr_time',

  /**
   * Grid row control type.
   */
  GridRow = 'grid_row',

  /**
   * Grid row value control type.
   */
  GridRowVal = 'grid_row_val',

  /**
   * Grid rows control type.
   */
  GridRows = 'grid_rows',

  /**
   * Grid sum control type.
   */
  GridSum = 'grid_sum',

  /**
   * Header control type.
   */
  Header = 'hdr',

  /**
   * Header control type, initally closed.
   */
  HeaderClosed = 'hdr-closed',

  /**
   * Header results control type.
   */
  HeaderResults = 'hdr-results',

  /**
   * Hidden control type.
   */
  Hidden = 'hid',

  /**
   * Multi-select picklist control type.
   */
  MultiPickList = 'lsm',

  /**
   * Percentage input control type.
   */
  Percentage = 'pct',

  /**
   * Picklist (dropdown) control type.
   */
  Picklist = 'ls',

  /**
   * Radio button picklist control type.
   */
  RadioButtonPicklist = 'lsr',

  /**
   * Region selector control type.
   */
  Region = 'reg',

  /**
   * Side panel control type.
   */
  SidePanel = 'side_panel',

  /**
   * Sub-header control type.
   */
  SubHeader = 'sub-hdr',

  /**
   * Sub-header sum control type.
   */
  SubHeaderSum = 'sub-hdr-sum',

  /**
   * Text input control type.
   */
  Text = 'txt',

  /**
   * Title control type.
   */
  Title = 'ttl',

  /**
   * Whole number (integer) input control type.
   */
  WholeNumber = 'int',

  /**
   * Yes/No (boolean) control type.
   */
  YesNo = 'ynu',

  /**
  * Grid for users to add custom adjustments.
  */
  GridCustomAdj = 'grid_custom_adj',

  /**
   * It can be used to wrap other controls or content to ensure they are displayed in a block format.
   * This makes it useful for scenarios where you want to control the visibility of a group of elements based on certain dependency conditions.
   * It is not a control type in the traditional sense, but rather a layout element.
   */
  DisplayBlock = 'display-block',

  /**
   * This is to sum the column in grid
   */
  ColumnSum = 'col_sum',

  /**
   * Grid formula column to perform calculation with configured formula
   */

  GridColFormula = 'grid-row-formula',

  /**
   * Volume change component
   */
  VolumeChange = 'volume-change',

}

export type EnumControlTypeKey = keyof typeof EnumControlTypes;
export type EnumControlTypeValue = typeof EnumControlTypes[EnumControlTypeKey];
